export const FETCH_BONUSES_DATA_SUCCESS = 'FETCH_BONUSES_DATA_SUCCESS';
export const FETCH_BONUSES_DATA_FAILURE = 'FETCH_BONUSES_DATA_FAILURE';
export const FETCH_LEADERBOARD_DATA_SUCCESS = 'FETCH_LEADERBOARD_DATA_SUCCESS';
export const FETCH_LEADERBOARD_DATA_FAILURE = 'FETCH_LEADERBOARD_DATA_FAILURE';
export const FETCH_ORGANIZATION_DATA_SUCCESS = 'FETCH_ORGANIZATION_DATA_SUCCESS';
export const FETCH_ORGANIZATION_DATA_FAILURE = 'FETCH_ORGANIZATION_DATA_FAILURE';
export const FETCH_PARTICIPATION_DATA_SUCCESS = 'FETCH_PARTICIPATION_DATA_SUCCESS';
export const FETCH_PARTICIPATION_DATA_FAILURE = 'FETCH_PARTICIPATION_DATA_FAILURE';
export const FETCH_TOP_WORDS_DATA_SUCCESS = 'FETCH_TOP_WORDS_DATA_SUCCESS';
export const FETCH_TOP_WORDS_DATA_FAILURE = 'FETCH_TOP_WORDS_DATA_FAILURE';
